import BaseService from './base.service';

export default class AccessControlService {
    static ENDPOINT = '/access-control';

    static async processVirtualGuardOtcAttempt(otcAttemptData) {
        const endpoint = `${this.ENDPOINT}/otc-access-attempt/virtual-guard`;
        return BaseService.post(endpoint, otcAttemptData);
    }

    static async grantVirtualGuardAccess(payload) {
        if (payload instanceof FormData) {
            return BaseService.postFormData(
                `${this.ENDPOINT}/virtual-guard/grant-access/multipart`,
                payload
            );
        }
        return BaseService.post(
            `${this.ENDPOINT}/virtual-guard/grant-access/json`,
            payload
        );
    }

    static async denyVirtualGuardAccess(payload) {
        if (payload instanceof FormData) {
            return BaseService.postFormData(
                `${this.ENDPOINT}/virtual-guard/deny-access/multipart`,
                payload
            );
        }
        return BaseService.post(
            `${this.ENDPOINT}/virtual-guard/deny-access/json`,
            payload
        );
    }
}
